enum PaymentOption {
  CreditCard = 1,
  WireTransfer = 2,
}

export default PaymentOption
